import React from 'react'

import styles from "./ViewBooked.module.css"

import InterviewTable from '../../../Components/Admin/InterviewTable/InterviewTable'

function ViewBooked() {
  return (
    <div className={styles.viewBooked}>
            <div className={styles.header}>Interviuri programate</div>

            <InterviewTable />
          </div>
  )
}

export default ViewBooked